import React, { useMemo, useState } from 'react';
import { Popover } from 'react-tiny-popover';
import '../../styles/InformationPopover.css';

export default function InformationPopover(props) {
    const [visible, setVisible] = useState(false);

    const informationContent = useMemo(() => {
        return (
            <div className="bg-light border p-2 rounded text-dark shadow-sm">
                {props.content}
            </div>
        );
    }, [props.content]);

    return (<Popover
        isOpen={visible}
        positions={['bottom', 'top', 'left', 'right']}
        content={informationContent}
        onClickOutside={() => setVisible(false)}
        containerClassName="popover-container"
    >
        <i className="bi bi-info-circle" onClick={() => setVisible(!visible)}></i>
    </Popover>);
}